import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function SchoolUniform() { 
  useEffect(() => {
    document.title = 'School Uniform-  CARMEL CONVENT SCHOOL, DHARUHERA';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li> Academics</li>
                <li>School Uniform</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">School Uniform</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
               <p><b> 1.</b> Students should come to school clean and neatly dressed in proper school uniform. </p>
               <p><b> 2.</b> Long hair must be plaited neatly and tied with a red band and in case of short hair, red hairbands are compulsory. </p>
               <p><b> 3.</b> Students are not permitted to wear ornaments or valuable wrist watches to school. Applying Henna, Nail Polish or any make up will be considered inappropriate. Streaking and colouring of hair is strictly banned. </p>
               <p><b> 4.</b> For reasons of decency and good taste, it is compulsory for all the students to wear an undershirt or slip and blue shorts as a part of the school uniform.</p>
               <div class="table-responsive maintable">
               <table class="table">
                   <thead>
                       <tr>
                           <th>Girls</th>
                           <th>Boys</th> 
                       </tr>
                   </thead>
                    <tbody>
                         <tr className="colorbg">
                            <td colspan="2"><b>Classes Nursery, L.KG, U.KG</b></td>
                         </tr>
                          <tr> <td> Red & white check shirt and bloomer  </td> <td>       Red & white check shirt </td> </tr>
                            <tr>  <td> White Socks with CCS         </td> <td>  Red solid plain shorts </td> </tr>
                            <tr> <td>  Black shoes with stripes     </td> <td>        White Socks with CCS </td> </tr>
                            <tr>  <td> Red hairband & Doodles       </td> <td>            Black shoes with stripes </td> </tr>
                            <tr className="colorbg">
                            <td colspan="2"> <b>Classes I - V </b></td>
                         </tr>
                         <tr><td> Light blue lined shirt       </td> <td>         Light blue lined shirt </td></tr>
                            <tr><td> Red & blue check skirt      </td> <td>           Red & blue check short   pants  (I - V) </td></tr>
                            <tr><td> White Socks with CCS        </td> <td>   White Socks with CCS </td></tr>
                            <tr><td> Black shoes with stripes    </td> <td>         Black shoes with stripes </td></tr>
                            <tr><td> Red hairband & Doodles </td> <td> </td></tr>
                            <tr className="colorbg">
                               <td colspan="2"><b>  Winter Uniform</b></td>
                           </tr>
                           <tr><td><b>Classes Nursery, L.KG, U.KG (Girls/Boys) </b> </td> <td><b>Classes I - V (Girls/Boys) </b></td></tr>
                            <tr> <td> Red jacket with hood and logo       </td><td>     Navy blue Jacket with hood,Red lower  yellow strips and logo </td> </tr>
                            <tr> <td>     Red & white skivi, white inner   </td><td>        Navy blue lower with yellow   strips </td> </tr>
                            <tr> <td>     Woolen grey socks          </td><td>      Woolen grey socks   </td> </tr>
                            <tr> <td> Black shoes with strips        </td><td>      Black shoes with strips </td> </tr>
                    </tbody>
                </table>
            </div>
            <h5>Squad System</h5>
                <p>The entire school community is divided into four Squads.  The Squad system aims to give the students an identity and a sense of pride in a supportive and secure environment.  It also encourages healthy competition and promotes achievements of the students in a positive manner.</p>
                <div class="table-responsive maintable">
                                <table class="table"> 
                                <tbody>
                                <tr> <td>   SQUAD </td> <td> SATYA (TRUTH)   </td><td>  EKTA  (UNITY) </td><td>  NAMRATA  (HUMILITY) </td><td> NIRMAL (PURITY)   </td>  </tr>
                                <tr> <td>  COLOUR  </td> <td>  BLUE</td><td>   GREEN </td><td>   RED </td><td>   YELLOW </td> </tr>
                                </tbody>
                                </table>
                                </div> 
           </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default SchoolUniform;
